import { Client } from 'api'
import { getActiveClient } from 'app/selectors'
import React from 'react'
import { useSelector } from 'react-redux'
import { OnboardingPageProps } from '../onboardingManager'
import { PrimaryOwnerComponent } from '../ownersComponents'
import { Button } from 'reactstrap'
import rightArrow from 'assets/images/Right-Arrow-White.svg'
import { getListOfOwnersWith25PercentShareOfClient } from './uboManagerHelper'

interface Props extends OnboardingPageProps {
  goBack: () => void
}

export const ControllingShareholders: React.FC<Props> = ({
  onNext,
  setCurrentPage,
  processingClientOnboarding,
  goBack,
}) => {
  const activeClient: Client = useSelector(getActiveClient)
  const controllingShareholders = getListOfOwnersWith25PercentShareOfClient(activeClient)

  function onContinue() {
    onNext({
      processingClientOnboardingValues: {
        ...processingClientOnboarding,
        ownersCompleted: true,
      },
      ownersValues: [...(activeClient.ownersAttributes || [])],
    })

    setCurrentPage(() => ({
      step: 'owners',
      state: 'primary_owner',
      rightPane: (
        <>
          <h3>Why we ask</h3>
          <p>
            We aim to electronically verify all beneficial owners, but we do enhanced verification on the primary
            beneficial owner who has the highest stake in the company.
          </p>
        </>
      ),
      component: PrimaryOwnerComponent,
    }))
  }

  return (
    <div>
      <h3>{activeClient.operatingAs} - Controlling Shareholders</h3>
      <h5>
        {"Here's who we've identified as owning 25% or more of"} {activeClient.operatingAs}
      </h5>

      {controllingShareholders.map((owner) => (
        <div key={owner.id}>
          {owner.share ? (owner.share * 100).toFixed(1) : ''}% -{' '}
          {owner.firstName && owner.lastName ? `${owner.firstName} ${owner.lastName}` : ''}
        </div>
      ))}

      <div className="d-flex justify-content-between mt-3">
        <Button type="button" color="primary" className="btn-rotessa-secondary" onClick={goBack}>
          Go back
        </Button>
        <Button
          title="Confirm"
          aria-label="Confirm"
          className="next-button d-flex align-items-center justify-content-center"
          onClick={onContinue}
        >
          Next
          <img src={rightArrow} className="ml-1" />
        </Button>
      </div>
    </div>
  )
}
